<script>
import { storeToRefs } from 'pinia';
import { useReservationStore } from '../../../store/contact/ReservationStore';

export default {
    setup() {
        const store = useReservationStore();
        const { setDetailValue } = store;
        const { personalDetail, personalDetailError } = storeToRefs(store);
        return {
            setDetailValue,
            personalDetail,
            personalDetailError,
        };
    },
};
</script>
<template>
    <div id="formStep1">
        <div class="fs-24px tw-text-darkGreen mb-30px">
            Let's get to know you. What would you like to talk about?
        </div>
        <form id="formStep2">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['firstname'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#firstName"
                            >First name
                            <span class="tw-text-red">*</span></label
                        >
                        <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            maxLength="100"
                            v-model="personalDetail['firstname']"
                            @change="
                                (e) =>
                                    setDetailValue('firstname', e.target.value)
                            "
                            :style="
                                personalDetailError['firstname'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                        />
                        {{ personalDetailError['firstname'] }}
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['middlename'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#middleName"
                            >Middle name</label
                        >
                        <input
                            type="text"
                            name="middleName"
                            id="middleName"
                            maxLength="100"
                            v-model="personalDetail['middlename']"
                            @change="
                                (e) =>
                                    setDetailValue('middlename', e.target.value)
                            "
                            :style="
                                personalDetailError['middlename'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                        />
                        {{ personalDetailError['middlename'] }}
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['lastname'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#lastName"
                            >Last name <span class="tw-text-red">*</span></label
                        >
                        <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            maxLength="100"
                            v-model="personalDetail['lastname']"
                            @change="
                                (e) =>
                                    setDetailValue('lastname', e.target.value)
                            "
                            :style="
                                personalDetailError['lastname'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                        />
                        {{ personalDetailError['lastname'] }}
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['email'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#email"
                            >Email <span class="tw-text-red">*</span></label
                        >
                        <input
                            type="text"
                            name="email"
                            id="email"
                            maxLength="100"
                            v-model="personalDetail['email']"
                            @change="
                                (e) => setDetailValue('email', e.target.value)
                            "
                            :style="
                                personalDetailError['email'] !== ''
                                    ? 'border-bottom: 1px solid red;'
                                    : ''
                            "
                        />
                        {{ personalDetailError['email'] }}
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['phone'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#mobileNumber"
                            >Mobile number
                            <span class="tw-text-red">*</span></label
                        >
                        <div class="tw-relative">
                            <span
                                class="tw-absolute tw-left-0 tw-text-[21px] tw-font-bold tw-text-midGreen"
                            >
                                <p class="tw-leading-[52px] tw-align-middle">
                                    +63
                                </p>
                            </span>
                            <input
                                maxLength="10"
                                v-model="personalDetail['phone']"
                                @change="
                                    (e) =>
                                        setDetailValue('phone', e.target.value)
                                "
                                type="text"
                                name="mobileNumber"
                                class="tw-w-full tw-pl-[40px]"
                                id="mobileNumber"
                                :style="
                                    personalDetailError['phone'] !== ''
                                        ? 'border-bottom: 1px solid red;'
                                        : ''
                                "
                            />
                            {{ personalDetailError['phone'] }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div
                        :class="
                            (personalDetailError['landline'] !== ''
                                ? 'tw-text-red'
                                : '') + ' form-group '
                        "
                    >
                        <label
                            class="fs-16px fw-medium tw-text-black"
                            for="#landlineNumber"
                            >Landline Number</label
                        >
                        <div class="tw-relative">
                            <span
                                class="tw-absolute tw-left-0 tw-text-[21px] tw-font-bold tw-text-midGreen"
                            >
                                <p class="tw-leading-[52px] tw-align-middle">
                                    02
                                </p>
                            </span>
                            <input
                                maxLength="8"
                                v-model="personalDetail['landline']"
                                @change="
                                    (e) =>
                                        setDetailValue(
                                            'landline',
                                            e.target.value
                                        )
                                "
                                type="text"
                                name="landlineNumber"
                                id="landlineNumber"
                                class="tw-w-full tw-pl-[30px]"
                                :style="
                                    personalDetailError['landline'] !== ''
                                        ? 'border-bottom: 1px solid red;'
                                        : ''
                                "
                            />
                            {{ personalDetailError['landline'] }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="fs-16px tw-text-darkGreen mb-50px">
            By clicking on the button below, I give my consent to Ortigas & Company Limited Partnership (OCLP) and to its subsidiaries, affiliates, partners, successors and assigns, and to their service providers and agents, to collect, possess, use, store and disclose any and all information and personal data furnished herein, or as may otherwise be provided by me, for the purpose of providing me information on their products and services, including but not limited to, offers, promotions, and new goods and services.
        </div>
    </div>
</template>
